module.exports = "<div id=J-aggrid></div>";


//////////////////
// WEBPACK FOOTER
// ./app/components/workflow/workflow-grid/workflow-grid.html
// module id = 4745
// module chunks = 50